import z from "zod";

// Form schema for payment channel
export const merchantPaymentChannelFormSchema = z.object({
  paymentChannelId: z.string(),
  additionalProp1: z.string(),
  additionalProp2: z.string(),
  additionalProp3: z.string(),
  active: z.boolean().default(true),
});

export const adminPaymentChannelFormSchema = z.object({
  name: z.string().min(3, { message: "Name must be at least 3 characters" }),
  description: z
    .string()
    .min(3, { message: "Description must be at least 3 characters" }),
  keyCheck: z.array(
    z.string().min(2, { message: "Key must be at least 2 character" }),
  ),
  active: z.boolean().default(true),
});

export type merchantPaymentChannelFormValues = z.infer<
  typeof merchantPaymentChannelFormSchema
>;
export type adminPaymentChannelFormValues = z.infer<
  typeof adminPaymentChannelFormSchema
>;
